export const PERMISSION_CUSTOMER = {
  CREATE: 'CustomerModule.create',
  VIEW: 'CustomerModule.view',
  UPDATE: 'CustomerModule.update',
  DELETE: 'CustomerModule.delete',
  EMAIL: 'CustomerModule.email',
  TRANSACTION: 'TransactionsModule.commit',
};
